import precognitive, { toSimpleValidationErrors } from 'laravel-precognition';
import { computed, ref } from 'vue';
export const patchVueForm = (method, url, form, validator) => {
    /**
     * The keys of the user's data.
     */
    const inputs = Object.keys(form);
    /**
     * Reactive errors state.
     */
    const errors = ref(toSimpleValidationErrors(validator.errors()));
    validator.on('errorsChanged', () => errors.value = toSimpleValidationErrors(validator.errors()));
    const hasErrors = computed(() => Object.keys(errors.value).length > 0);
    /**
     * Patch the form.
     */
    return Object.assign(form, {
        errors,
        hasErrors,
        setErrors(errors) {
            validator.setErrors(errors);
            return this;
        },
        clearErrors() {
            validator.clearErrors();
            return this;
        },
        data() {
            return inputs.reduce((carry, key) => ({
                ...carry,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                [key]: this[key],
            }), {});
        },
        async submit(config) {
            return precognitive.axios()[method](url, this.data(), config).catch((error) => {
                if (error.response?.status === 422) {
                    this.setErrors(error.response.data.errors);
                }
                return Promise.reject(error);
            });
        },
    });
};
